module.exports = __webpack_public_path__ + "img/unauthorized.e83a8ea4.svg";